// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7d25fa54","171":"7f5dc081","432":"a18951ba","994":"76134447"}[chunkId] + ".chunk.js";
};